'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect, useState } from 'react';
import { writeChartMetricCookie } from '@/lib/chart/metric-preference';
import { writeChartTimeframeCookie } from '@/lib/chart/timeframe-preference';
import { useChartIntentSelection, useChartIntentStore } from '@/stores/chart-intent';
import { useChartSettingsStore } from '@/stores/chart-settings';
const useIsomorphicLayoutEffect: typeof useLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

/** Keep a warmed representation; cold detail navigation still opens as a line. */
export function useMarketDetailChartDefault(marketPubkey) {
  const $ = _c(8);
  const selection = useChartIntentSelection(useChartIntentStore());
  const renderMode = selection?.kind === "market" && selection.marketPubkey === marketPubkey ? selection.renderMode : "line";
  let t0;
  if ($[0] !== marketPubkey) {
    t0 = {
      marketPubkey,
      applied: false
    };
    $[0] = marketPubkey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [opening, setOpening] = useState(t0);
  if (opening.marketPubkey !== marketPubkey) {
    setOpening({
      marketPubkey,
      applied: false
    });
  }
  let t1;
  if ($[2] !== renderMode) {
    t1 = s => s.renderMode === renderMode;
    $[2] = renderMode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const matchesOpening = useChartSettingsStore(t1);
  let t2;
  let t3;
  if ($[4] !== opening.applied || $[5] !== renderMode) {
    t2 = () => {
      if (opening.applied) {
        return;
      }
      useChartSettingsStore.setState({
        renderMode
      });
      writeChartMetricCookie(useChartSettingsStore.getState());
      writeChartTimeframeCookie(useChartSettingsStore.getState().interval);
      setOpening(_temp);
    };
    t3 = [opening.applied, renderMode];
    $[4] = opening.applied;
    $[5] = renderMode;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useIsomorphicLayoutEffect(t2, t3);
  return opening.applied || matchesOpening;
}
function _temp(current) {
  return {
    ...current,
    applied: true
  };
}